import React from "react";
import styles from "./tableShimmer.module.css";

interface TableShimmerProps {
  rows?: number;
  /** flex weights per column, left to right */
  columnWidths?: number[];
}

const TableShimmer: React.FC<TableShimmerProps> = ({
  rows = 6,
  columnWidths = [3, 1, 2, 1, 2],
}) => (
  <div className={styles.wrapper}>
    {Array.from({ length: rows }).map((_, i) => (
      <div key={i} className={styles.row}>
        {columnWidths.map((flex, j) => (
          <div key={j} className={styles.cell} style={{ flex }} />
        ))}
      </div>
    ))}
  </div>
);

export default TableShimmer;
